import React, {
	useEffect, useState
}from "react"
import {
	 Modal, Form, Select, Checkbox
}from "antd"
import {
	useDispatch,
	useSelector
}from 'react-redux'
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import {
	reMeasurementUnitActions
}from "../ReMeasurementUnit/store/actions"
import {
	useDebounce
}from "use-debounce"
import CustomSelect from "../../../components/CustomSelect"

const ReCharacteristicChangeForm = ({ visible, setVisible, setRecord, record, create, update }) => {
	const [searchUnit, setSearchUnit] = useState('')

	const { isSending, changed } = useSelector(state => state.reCharacteristicReducer)
	const units = useSelector(state => state.reMeasurementUnitReducer.list)

	const [unit] = useDebounce(searchUnit, 500)

	const [form] = Form.useForm()
	const dispatch = useDispatch()

	const getMeasurementUnits = (values) => {
		dispatch(reMeasurementUnitActions.getList(values))
	}

	useEffect(() => {
		return () => {
			dispatch(reMeasurementUnitActions.clear())
		}
	}, [])

	useEffect(() => {
		form.resetFields()
		if (record){
			form.setFieldsValue({
				code       : record.code,
				name       : record.name,
				unit       : record.measurementUnit,
				isSelect   : record.isSelect,
				type       : record.type,
				deviation  : record.deviation,
				createDate : record?.createDate
			})
		}
	}, [record])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	useEffect(() => {
		getMeasurementUnits({
			name: unit
		})
	}, [unit])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setRecord(null)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id                : record?.id,
				code              : values.code,
				name              : values.name.trim(),
				measurementUnitId : values.unit,
				isSelect          : values.isSelect,
				type              : values.type,
				deviation         : values.deviation,
				createDate        : record?.createDate
			}
			const previousValues = {
				id                : record?.id,
				code              : record?.code,
				name              : record?.name,
				measurementUnitId : record?.unit,
				isSelect          : record?.isSelect,
				type              : record?.type,
				deviation         : record?.deviation,
				createDate        : record?.createDate
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice("Введенные вами данные полностью соответствуют изначальным.", null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnClose
			footer={ [
				<CustomButton
					key="save"
					loading={ isSending }
					type="green"
					onClick={ save }
				>
                    Сохранить
				</CustomButton>
			] }
			title={ record ? "Редактирование записи" : "Добавление записи" }
			visible={ visible }
			width={ 900 }
			onCancel={ handleCancel }
		>
			<Form
				form={ form }
				labelAlign="left"
				labelCol={ { span: 6 } }
				name="nsi-form"
				wrapperCol={ { span   : 16,
					offset : 1 } }
			>
				<Form.Item
					label="Код"
					name="code"
					rules={ [
						{
							required : true,
							message  : "Код заполнен некорректно.",
							pattern  : /^[1-9]\d{0,6}$/
						}
					] }
				>
					<CustomInput
						placeholder="Код"
						readOnly={ Boolean(record) }
					/>
				</Form.Item>
				<Form.Item
					label="Наименование"
					name="name"
					rules={ [
						{
							required   : true,
							whitespace : true,
							min        : 3,
							max        : 200
						}
					] }
				>
					<CustomInput
						maxLength={ 250 }
						placeholder="Наименование"
					/>
				</Form.Item>
				<Form.Item
					label="Выбирается ли из возможных вариантов"
					name="isSelect"
					valuePropName="checked"
				>
					<Checkbox />
				</Form.Item>
				<Form.Item
					label="Единица измерения"
					name="unit"
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						notFoundContent={ null }
						placeholder="Выберите единицу измерения"
						onSearch={ (e) => setSearchUnit(e) }
					>
						{ units?.map(unit => {
							return (
								<Select.Option
									key={ unit.id }
									value={ unit.id }
								>
									{ unit.name }
								</Select.Option>)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Соответствие"
					name="deviation"
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						notFoundContent={ null }
						placeholder="Выберите соответствие"
					>
						<Select.Option
							key="none"
							value={ 1 }
						>
                            Отсутствует
						</Select.Option>
						<Select.Option
							key="full"
							value={ 2 }
						>
                            Полное
						</Select.Option>
						<Select.Option
							key="partly"
							value={ 3 }
						>
                            Частичное
						</Select.Option>
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Тип"
					name="type"
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						notFoundContent={ null }
						placeholder="Выберите тип"
					>
						<Select.Option
							key="string"
							value={ 1 }
						>
                            Текст
						</Select.Option>
						<Select.Option
							key="number"
							value={ 2 }
						>
                            Число
						</Select.Option>
					</CustomSelect>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReCharacteristicChangeForm
